<template>
    <section class="user-header-box">
        <div class="">
            <nav class="nav">
                <div class="nav-left">
                    <p class="user-name">ようこそ、{{user_name}} 様</p>
                    <h1 class="title"><span class="logo"></span><span class="title-text">あなただけの、オリジナルブレンド茶</span></h1>
                </div>
            </nav>
        </div>
    </section>
</template>

<script>
export default {
  name: 'UserHeader',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    user_name () {
      return this.$store.getters['uLoginInfo/user_name'];
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.user-header-box {
  width: 100%;
  height: 48px;
  border-bottom: 4px solid #df274c;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 20;
  text-align: left;
  background-color: #fefefe;
  color: #5c5945;
  .user-name {
    float: right;
    padding: 5px 20px 0 0;
  }
  .nav-left {
    h1.title {
      margin: 6px 0px 0px 6px;
      color: #212617;
    }
    .logo {
      width: 150px;
      height: 36px;
      margin: 0px 0px 0px 0px;
      color: #212617;
      background-image: url('../../../assets/order_logo.svg');
      background-repeat: no-repeat;
      display: inline-block;

    }
    .title-text {
      font-size: 20px;
      top: 9px;
      position: fixed;
    }
  }
  @media (max-width: 767px) {
    .title-text, .user-name {
      display: none;
    }
  }
}
</style>
